'use client'

import { legalNoticeDrawerAtom } from '@/feature/coupon/services/coupon.store'
import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { Link } from '@/ui/links/link/Link.client'
import { gql } from '@apollo/client'
import { useSetAtom } from 'jotai'
import sanitizeHtml from 'sanitize-html'

gql(/* GraphQL */ `
  fragment ProductMarketingInsertTag_Product on Product {
    marketingInsert {
      label
      legalNotice
    }
  }
`)

type ProductMarketingInsertTagProps = {
  /** The marketing insert to display */
  label: string
  legalNotice: string
}

export function ProductMarketingInsertTag({ label, legalNotice }: ProductMarketingInsertTagProps) {
  const { t } = useTranslation(['applyCouponCodeForm'])
  const setLegalNoticeAtomState = useSetAtom(legalNoticeDrawerAtom)

  const handleOpenLegalNoticeDrawer = () => {
    setLegalNoticeAtomState({ isOpen: true, content: legalNotice })
  }

  return (
    <div className="mb-3 flex items-center justify-between gap-2 rounded-sm bg-info-bg p-1 text-info-fg">
      <span
        className="font-medium leading-light"
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(label),
        }}
      />
      <Link
        variant="free"
        href="#"
        onPress={handleOpenLegalNoticeDrawer}
        bold
        underlined="invert"
        data-testid="link/legal-notice-button"
        className="flex min-w-18 shrink-0 items-center justify-center gap-1 text-sm"
      >
        {t('applyCouponCodeForm:legalNotice')}
      </Link>
    </div>
  )
}
